import React, { memo, useState } from 'react'
import { useDropdownState } from 'hooks/useDropdownState'
import { useMobileInnerSliderCallbacks } from 'hooks/useMobileInnerSliderCallbacks'
import AiReferenceImagesFlyOut from './FlyOut'
import AiReferenceImagesItem from './Item'
import AddReferenceImageButton from './Add'
import { IReferenceImage } from 'store/types/aiImage'
import { IProps } from './types'
import * as Styled from './styled'

const AiReferenceImagesContainer: React.FC<IProps> = ({
  images,
  onAddMediaImage,
  onUploadImage,
  availableImagesCount,
  isUploading
}) => {
  const [addImageWrapperElement, setAddImageWrapperElement] =
    useState<HTMLDivElement | null>(null)

  const { openCallback, closeCallback } = useMobileInnerSliderCallbacks()
  const { isOpen, toggleDropdown, closeDropdown } = useDropdownState(
    openCallback,
    closeCallback
  )

  return (
    <>
      <Styled.ReferenceImagesContainer>
        {!!availableImagesCount && (
          <AddReferenceImageButton
            toggleDropdown={toggleDropdown}
            isOpen={isOpen}
            setAddImageWrapperElement={setAddImageWrapperElement}
            isUploading={isUploading}
          />
        )}
        {images.map((image: IReferenceImage) => (
          <AiReferenceImagesItem item={image} key={image.id} />
        ))}
      </Styled.ReferenceImagesContainer>

      <AiReferenceImagesFlyOut
        availableImagesCount={availableImagesCount}
        onAddMediaImage={onAddMediaImage}
        onUploadImage={onUploadImage}
        isOpen={isOpen}
        closeDropdown={closeDropdown}
        addImageWrapperElement={addImageWrapperElement}
      />
    </>
  )
}

export default memo(AiReferenceImagesContainer)
